import React, { useState, useEffect } from 'react';
import API_ROUTES from './config/apiConfig';
import { getPublicRequest } from '../api/auth';

export default function CategoryProducts({
  categorySlug,
  subCategorySlug,
  onNavigate
}) {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (categorySlug) {
      fetchProducts();
    }
  }, [categorySlug, subCategorySlug]);

  const fetchProducts = async () => {
    try {
      setLoading(true);

      // Parent category ke products fetch honge
      const res = await getPublicRequest(
        `${API_ROUTES.GET_PRODUCTS}?category=${categorySlug}`
      );

      const allProducts = res.data?.items || [];

      // Agar subcategory URL mein hai,
      // sirf us subcategory ke products rakho
      const filteredProducts = subCategorySlug
        ? allProducts.filter(
            (product) =>
              product.subCategory?.slug === subCategorySlug
          )
        : allProducts;

      setProducts(filteredProducts);

      // Category information
      if (filteredProducts.length) {
        setCategory(filteredProducts[0].categoryId);
      } else if (allProducts.length) {
        setCategory(allProducts[0].categoryId);
      } else {
        setCategory(null);
      }

    } catch (err) {
      console.log("Failed to fetch products:", err);
      setProducts([]);
      setCategory(null);
    } finally {
      setLoading(false);
    }
  };

  const getProductImage = (product) => {
    return (
      product.primaryImage?.url ||
      product.primaryImage?.filePath ||
      product.images?.find((img) => img.isPrimary)?.url ||
      product.images?.[0]?.url ||
      "/no-image.png"
    );
  };

  if (loading) {
    return (
      <div className="container py-5 text-center text-white">
        Loading...
      </div>
    );
  }

  return (
    <div className="creative-lamp-universe">

      {/* CINEMATIC BACKGROUND GLOWS */}
      <div className="ambient-space-glow-1"></div>
      <div className="ambient-space-glow-2"></div>

      {/* HERO */}
      <section className="creative-hero-section">
        <div className="container animation-slide-up">

          <span className="premium-eyebrow">
            <span className="diya-accent">🪔</span>
            ARCHITECTURAL LUMINESCENCE
          </span>

          <h1 className="creative-main-title">
            {subCategorySlug
              ? products[0]?.subCategory?.name || subCategorySlug
              : category?.name
            }

            <span className="gold-gradient-text">
              Ambient Curations
            </span>
          </h1>

          <div className="title-underline-glow"></div>

          <p className="creative-hero-subtitle">
            Explore elite, glare-free architectural accent fixtures
            designed to elevate luxury suites, boutique lounges, and
            high-end residential spaces at dusk.
          </p>

        </div>
      </section>

      {/* PRODUCTS */}
      <section className="container catalog-grid-container">

        {products.length > 0 ? (

          <div className="creative-lamps-mesh">

            {products.map((product) => (

              <div
                key={product._id}
                className="luxury-product-card"
              >

                {/* IMAGE */}
                <div
                  className="luxury-card-media"
                  onClick={() =>
                    onNavigate("pdp", {
                      slug: product.slug
                    })
                  }
                >

                  <div className="media-vintage-grain"></div>

                  <img
                    src={getProductImage(product)}
                    alt={product.title}
                    className="luxury-card-img"
                    loading="lazy"
                  />

                  {product.isFeatured && (
                    <div className="edition-floating-tag">
                      Featured
                    </div>
                  )}

                </div>

                {/* DETAILS */}
                <div className="luxury-card-details">

                  <div className="luxury-meta-row">

                    <span className="luxury-tag">
                      {product.material || "Handcrafted"}
                    </span>

                    <span className="meta-bullet">
                      •
                    </span>

                    <span className="luxury-tag">
                      {product.style || "Bespoke"}
                    </span>

                  </div>

                  <h3
                    className="luxury-card-title"
                    onClick={() =>
                      onNavigate("pdp", {
                        slug: product.slug
                      })
                    }
                  >
                    {product.title}
                  </h3>

                  <p className="luxury-card-description">
                    {product.description}
                  </p>

                  {/* ACTIONS */}
                  <div className="luxury-card-actions">

                    <button
                      type="button"
                      className="btn-luxury-enquire"
                      onClick={() =>
                        onNavigate("contact")
                      }
                    >
                      Enquire Specs
                    </button>

                    <button
                      type="button"
                      className="btn-luxury-details"
                      onClick={() =>
                        onNavigate("pdp", {
                         slug: product.slug
                        })
                      }
                    >
                      Product Details
                    </button>

                  </div>

                </div>

              </div>

            ))}

          </div>

        ) : (

          <div className="glass-empty-state animation-fade-in">

            <span className="empty-state-icon">
              🔍
            </span>

            <h3>
              No Products Found
            </h3>

            <p>
              No products are currently available in this collection.
            </p>

          </div>

        )}

      </section>

    </div>
  );
}
